import React, { useState, useEffect } from "react";
import ResetPasswordView from "./ResetPasswordView";
import NewPasswordView from "./NewPasswordView";
import ConfirmationCodeView from "./ConfirmationCodeView";
import { Auth } from "aws-amplify";
import SignUpView from "./SignUpView";
import LoginView from "./LoginView";

const AuthView = ({ onUserSignedIn }) => {
  const [currentView, setCurrentView] = useState("login");
  // other necessary state variables
  const [username, setUsername] = useState("");
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [errorSignIn, setErrorSignIn] = useState("");
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [signupError, setSignupError] = useState("");
  const [isConfirming, setIsConfirming] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [isResendingCode, setIsResendingCode] = useState(false);
  const [errorResendCode, setErrorResendCode] = useState("");
  const [errorCreateAccount, setErrorCreateAccount] = useState("");
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [errorResetPassword, setErrorResetPassword] = useState("");
  const [isSubmitingNewPassword, setIsSubmitingNewPassword] = useState(false);
  const [errorNewPassword, setErrorNewPassword] = useState("");

    // Centralized navigation function
    const navigateToView = (view) => {
      // Reset all errors
      setErrorSignIn("");
      setSignupError("");
      setConfirmError("");
      setErrorResendCode("");
      setErrorCreateAccount("");
      setErrorResetPassword("");
      setErrorNewPassword("");
  
      // Navigate to the specified view
      setCurrentView(view);
    };


  // Functions to handle authentication logic
  const handleSignIn = async (username, password) => {
    setIsSigningIn(true);
    try {
      const user = await Auth.signIn(username, password);
      onUserSignedIn && onUserSignedIn(true);
      if (user) setIsSigningIn(false);
      else{
        setErrorSignIn("Something went wrong. Please try again.");
        setIsSigningIn(false);
      }
    } catch (error) {
      setErrorSignIn(error.message);
    } finally {
      setIsSigningIn(false);
    }
  };

  const handleCreateAccount = async (username, password, email) => {
    setIsSigningUp(true);
    setUsername(username);      
    try {
      const signUpResponse = await Auth.signUp({
        username,
        password,
        attributes: {
          email,
        },
      });
      console.log("signUpResponse", signUpResponse);
      setIsSigningUp(false);
      navigateToView("confirmCode");
    } catch (error) {
      setIsSigningUp(false);
      setSignupError(error.message);
    }
  };

  const handleConfirmSignUp = async (code) => {
    setIsConfirming(true);
    try {
      await Auth.confirmSignUp(username, code);
      setIsConfirming(false);
      navigateToView("login");
    } catch (error) {
      setConfirmError(error.message);
      setIsConfirming(false);
      console.log("error confirming sign up", error);
    }
  };

  const handleResetPassword = async (username) => {
    setIsResettingPassword(true);
    try {
      setUsername(username);      
      const response = await Auth.forgotPassword(username);
      console.log("Password reset request sent successfully", response);
      setIsResettingPassword(false);
      navigateToView("newPassword");
    } catch (error) {
      setErrorResetPassword(error.message);
      console.error("Error sending password reset request", error);
    }
    finally{
      setIsResettingPassword(false);
    } 
  };

  const handleSubmitNewPassword = async (code, newPassword) => {
    setIsSubmitingNewPassword(true);
    try {
      await Auth.forgotPasswordSubmit(username, code, newPassword);
      setIsSubmitingNewPassword(false);
      navigateToView("login");
      return true;
    } catch (error) {
      setErrorNewPassword(error.message);
      setIsSubmitingNewPassword(false);
      console.error("Error resetting password", error);
    }
  };
  const handleResendCode = async () => {
    setIsResendingCode(true);
    try {
      const response = await Auth.forgotPassword(username);
      setIsResendingCode(false);
      console.log("Password reset request sent successfully", response);
    } catch (error) {
      setErrorResendCode(error.message);
      setIsResendingCode(false);
      console.error("Error sending password reset request", error);
    }
  };
  useEffect(() => {
    const checkCurrentUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (user) {
          onUserSignedIn(true);
        }
      } catch {
        // No current user, do nothing
      }
    };

    checkCurrentUser();
  }, [onUserSignedIn]);

  return (
    <div>

      {currentView === "login" && (
        <LoginView
          error={errorSignIn}
          onSignIn={handleSignIn}
          isLoading={isSigningIn}          
          onNavigate={() => navigateToView("resetPassword")}
          onNavigateToSignup={() => navigateToView("signup")}
        />
      )}
      {currentView === "resetPassword" && (
        <ResetPasswordView
          error={errorResetPassword}
          isLoading={isResettingPassword}
          onSendResetRequest={handleResetPassword}
          onNavigate={() => navigateToView("login")}
        />
      )}
      {currentView === "newPassword" && (
        <NewPasswordView
          error={errorNewPassword}
          isLoading={isSubmitingNewPassword}
          onResendCode={handleResendCode}
          onSubmitnewPassword={handleSubmitNewPassword}
        />
      )}
      {currentView === "confirmCode" && (
        <ConfirmationCodeView
          isLoading={isConfirming}          
          error={confirmError}
          onSubmitConfirmationCode={handleConfirmSignUp}
        />
      )}
      {currentView === "signup" && (
        <SignUpView
          isLoading={isSigningUp}
          error={signupError}
          onCreateAccount={handleCreateAccount}
          onNavigateToSignIn={() => navigateToView("login")}
        />
      )}
    </div>
  );
};

export default AuthView;
